module.exports = __webpack_public_path__ + "static/img/1_4.76fba0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/1_4.png
// module id = KN+T
// module chunks = 44